import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src767378012/src/scriptunlock-production/node_modules/next/dist/client/app-dir/link.js");
